import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createAgentsBalanceReportSlice = (set, get) => ({
    agentsBalance: {
        loading: false,
        data: [],
    },
    getAgentsBalance: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ agentsBalance: { ...state.agentsBalance, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: "/v1/business/get-agent-balance",
                headers: { token },
            });
            set(state => ({ agentsBalance: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ agentsBalance: { ...state.agentsBalance, loading: false } }));
        }
    }
});
